<template>
  <div class="sort-field">
    <label id="ordering-lbl" for="ordering">Sort by</label>
    <div
      class="selecter min-width-selecter"
      :class="[isSortClosed ? 'closed' : 'open']"
      tabindex="0"
      @click="isSortClosed = !isSortClosed"
    >
      <span class="selecter-selected">{{ getSort }}</span>
      <div v-if="host == 'allenandunwin'" class="selecter-options">
        <span
          class="selecter-item"
          v-for="(sort, i) in sorts"
          @click="selected_sort_index = i"
          >{{ sort.name }}</span
        >
      </div>
      <div v-else class="selecter-options">
        <span
          class="selecter-item"
          v-for="(sort, i) in sortsNz"
          @click="selected_sort_index = i"
          >{{ sort.name }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fiction-sort-books",
  data() {
    return {
      isSortClosed: true,
      selected_sort_index: 0,
      sorts: [
        { name: "By Publication Date (Newest)", code: "date_asc" },
        { name: "Price (high to low)", code: "price_asc" },
        { name: "Price (low to high)", code: "price_desc" },
      ],
      sortsNz: [
        { name: "Title", code: "title" },
        { name: "By Publication Date (Newest)", code: "date_asc" },
        { name: "By Publication Date (Latest)", code: "date_desc" },
        { name: "Price (high to low)", code: "price_asc" },
        { name: "Price (low to high)", code: "price_desc" },
      ],
      host: this.$store.state.site_data.host,
    };
  },
  computed: {
    getSort() {
  const sortArray = this.host === "allenandunwin" ? this.sorts : this.sortsNz;
  const sort = sortArray[this.selected_sort_index];
  return sort ? sort.name : "";
}
  },
  mounted() {
    // Initial index depending on host
    this.selected_sort_index = this.host === "allenandunwin" ? 0 : 3;
    this.emitSort(); // Emit initial sort
  },
  watch: {
    selected_sort_index(newIndex, oldIndex) {
      if (newIndex !== oldIndex) {
        this.emitSort();
      }
    },
  },
  methods: {
    emitSort() {
      const sortArray = this.host === "allenandunwin" ? this.sorts : this.sortsNz;
      const sort = sortArray[this.selected_sort_index];
      if (sort) {
        this.$emit("sort-search-books", sort.code);
      }
    },
  },
};
</script>

<style>
.sort-field {
  float: right;
  margin-top: 0px !important;
}
.min-width-selecter {
  min-width: 322px;
  margin-left: 10px;
}
</style>